import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { InstagramData } from '../../../shared/public-api';

@Component({
  selector: 'admin-instagram-section',
  templateUrl: './instagram-section.component.html',
  styleUrls: ['./instagram-section.component.scss'],
  imports: [CommonModule, FormsModule, InputTextModule],
})
export class InstagramSectionComponent implements OnInit {
  @Input() sectionData: InstagramData;
  @Output() sectionDataChange = new EventEmitter<any>();

  constructor() {}

  ngOnInit(): void {
    if (!this.sectionData) {
      this.sectionData = new InstagramData();
    }
  }
}
